import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {DragulaModule} from 'ng2-dragula';
import {AdminAbstractModule} from 'gp-admin-abstract';

import {AlertComponent} from './components/alert/alert.component';
import {SpinboxComponent} from './components/spinbox/spinbox.component';
import {SelectComponent} from './components/select/select.component';
import {InputComponent} from './components/input/input.component';
import {TextareaComponent} from './components/textarea/textarea.component';
import {ImageUploadComponent} from './components/image-upload/image-upload.component';
import {YandexMapComponent} from './components/yandex-map/yandex-map.component';
import {PhoneInputComponent} from './components/phone-input/phone-input.component';
import {ButtonComponent} from './components/button/button.component';
import {SwitchButtonComponent} from './components/switch-button/switch-button.component';
import {RadioButtonComponent} from './components/radio-button/radio-button.component';
import {MultiselectComponent} from './components/multiselect/multiselect.component';
import {PopupComponent} from './components/popup/popup.component';
import {CheckboxComponent} from './components/checkbox/checkbox.component';

import {ScrollDirective} from './directives/scroll/scroll.directive';
import {DDSortDirective} from './directives/dd-sort/dd-sort.directive';


export class AdminUxModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        DragulaModule,
        AdminAbstractModule.forRoot()
    ],
    declarations: [
        AlertComponent,
        SpinboxComponent,
        SelectComponent,
        InputComponent,
        TextareaComponent,
        ImageUploadComponent,
        YandexMapComponent,
        PhoneInputComponent,
        ButtonComponent,
        SwitchButtonComponent,
        RadioButtonComponent,
        MultiselectComponent,
        PopupComponent,
        ScrollDirective,
        DDSortDirective,
        CheckboxComponent
    ],
    exports: [
        AlertComponent,
        SpinboxComponent,
        SelectComponent,
        InputComponent,
        TextareaComponent,
        ImageUploadComponent,
        YandexMapComponent,
        PhoneInputComponent,
        ButtonComponent,
        SwitchButtonComponent,
        RadioButtonComponent,
        MultiselectComponent,
        PopupComponent,
        CheckboxComponent,
        ScrollDirective,
        DDSortDirective
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
